import { useEffect } from 'react';
import Cookies from 'js-cookie';
import {
  FROM_REVIEW_PARAM,
  REVIEW_CLICK_ID_PARAM,
  REVIEW_SOURCE_KEY,
  REVIEW_CLICK_ID_KEY,
  REVIEW_TS_KEY,
  REVIEW_COOKIE_DAYS,
} from '../constants';

const cookieOptions = { expires: REVIEW_COOKIE_DAYS, path: '/', sameSite: 'lax' as const };

export const useInitReviewPurchaseTracking = () => {
  useEffect(() => {
    if (typeof window === 'undefined') return;
    const params = new URLSearchParams(window.location.search);
    if (params.get(FROM_REVIEW_PARAM) !== '1') return;

    const reviewClickId = params.get(REVIEW_CLICK_ID_PARAM) || '';

    Cookies.set(REVIEW_SOURCE_KEY, '1', cookieOptions);
    if (reviewClickId) {
      Cookies.set(REVIEW_CLICK_ID_KEY, reviewClickId, cookieOptions);
    }
    Cookies.set(REVIEW_TS_KEY, String(Date.now()), cookieOptions);
  }, []);
};
